<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

export default {
  page: {
    title: "Mecanismo de comunicaciones",
    meta: [{ name: "procedimiento-auditoria", content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    Style,
  },

  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },

        {
          text: "Mecanismo de comunicaciones",
          active: true,
        },
      ],
      loading: true,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companies_id: this.$store.getters["company/getCompany"].id || null,
    };
  },

  methods: {
    /**
     * Vuelve a la pagina anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde el item 2.8.1, asi que no se puede fijar el
     * destino. Si no hay historial (entrada directa o refresh) cae a la base
     * de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },

}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="col-12">
      <div class="card">
        <div class="card-body">

          <div class="row">
            <div class="col-9">
              <h4 class="header-title">MECANISMO DE COMUNICACIONES DEL SISTEMA DE GESTIÓN DE SEGURIDAD Y SALUD EN EL
                TRABAJO SG SST</h4>
            </div>
            <div class="col-3 text-right">
              <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                <i class="fas fa-arrow-left"></i>
              </button>
              <b-tooltip target="tooltip" placement="left">Volver a la página anterior</b-tooltip>
            </div>
          </div>

          <br>

          <b-row>
            <p>
              <strong>DEFINICIONES</strong>
            </p>
          </b-row>

          <b-row>
            <ul>
              <li><strong>COMUNICACIÓN:</strong>
                Es un medio de conexión que tenemos las personas para trasmitir o intercambiar
                mensajes con el fin de dar, recibir o intercambiar ideas, información o algún significado.
              </li>
              <li><strong>COMUNICACIÓN INTERNA:</strong>
                Comunicación escrita, realizada entre dos miembros de la organización.
              </li>
              <li><strong>COMUNICACIÓN EXTERNA:</strong>
                Comunicación escrita entre la empresa y sus clientes, proveedores, contratistas o entes reguladores;
                puede ser: correo electrónico o carta de la empresa.
              </li>
              <li><strong>PARTE INTERESADA:</strong>
                Individuo o grupo relacionado o afectado tanto interno como externo a la institución y que tienen un
                interés en el desempeño o éxito de esta. Para este caso aplica:
                <ul>
                  <li>Personal propio.</li>
                  <li>Personal contratista y subcontratista.</li>
                  <li>Clientes.</li>
                  <li>Proveedores.</li>
                  <li>Entes de control.</li>
                </ul>
              </li>
              <li><strong>CARTELERA:</strong>
                Cartel anunciador cuya finalidad es motivar un buen clima laboral, herramienta para capacitación y para
                retroalimentación de los procesos de comunicación de la empresa
              </li>
              <li><strong>MEMORANDOS:</strong>
                Comunicación escrita de carácter interno de una empresa que se utiliza para trasmitir información
                orientaciones y pautas a todas las áreas.
              </li>
              <li><strong>LLAMADOS DE ATENCIÓN:</strong>
                En su sentido más genérico, es una crítica hecha con la intención de evitar que se repita un
                comportamiento indeseado.
              </li>
              <li><strong>COMUNICACIÓN MASIVA:</strong>
                Comunicación escrita de carácter masivo (Dirigida a varios miembros de la organización). Correo
                electrónico, redes sociales, carta con membrete de la empresa, entre otras que se consideren efectivas
                para dicha comunicación.
              </li>
            </ul>
          </b-row>

          <b-row>
            <ol>
              <li>
                <strong>COMUNICACIONES INTERNAS</strong>
                <table class="table table-bordered tg">
                  <thead>
                    <tr>
                      <th class="tg-9wq8"><strong>TEMA A COMUNICAR</strong></th>
                      <th class="tg-9wq8"><strong>A QUIEN SE COMUNICA</strong></th>
                      <th class="tg-9wq8"><strong>MEDIOS DE COMUNICACIÓN</strong></th>
                      <th class="tg-9wq8"><strong>FRECUENCIA</strong></th>
                      <th class="tg-9wq8"><strong>REGISTROS / EVIDENCIA</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="tg-9wq8" rowspan="7">Política de SST</td>
                      <td class="tg-9wq8" rowspan="4">A todos los empleados</td>
                      <td class="tg-9wq8">Cartelera</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Foto</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Inducción</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Reinducción</td>
                      <td class="tg-9wq8">Anual</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Capacitación</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="3">A todas las partes interesadas</td>
                      <td class="tg-9wq8">Cartilla para visitantes</td>
                      <td class="tg-9wq8">Cada vez que ingrese un visitante</td>
                      <td class="tg-9wq8">Registro de visitantes.</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Cartelera</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Foto</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Inducción</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Reglamento de Higiene y seguridad.</td>
                      <td class="tg-9wq8">A todos los empleados</td>
                      <td class="tg-9wq8">Inducción</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="5">Peligros y riesgos</td>
                      <td class="tg-9wq8" rowspan="3">A todos los empleados</td>
                      <td class="tg-9wq8">Inducción</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Reinducción</td>
                      <td class="tg-9wq8">Anual</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Capacitaciones</td>
                      <td class="tg-9wq8">Anual</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="2">Partes interesadas</td>
                      <td class="tg-9wq8">Cartilla para visitantes</td>
                      <td class="tg-9wq8">Cada vez que ingrese un visitante</td>
                      <td class="tg-9wq8">Registro de visitantes.</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Inducción</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="3">Objetivos</td>
                      <td class="tg-9wq8" rowspan="3">A todos los empleados y partes interesadas</td>
                      <td class="tg-9wq8">Inducción / Reinducción</td>
                      <td class="tg-9wq8">Cuando sea necesario</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Cartelera</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Foto</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Capacitaciones</td>
                      <td class="tg-9wq8">Dos veces al año</td>
                      <td class="tg-9wq8">Registro de capacitaciones.</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Requisitos legales</td>
                      <td class="tg-9wq8">A todos los empleados</td>
                      <td class="tg-9wq8">Capacitaciones</td>
                      <td class="tg-9wq8">Cada vez que haya nueva reglamentación</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Funciones, responsabilidades</td>
                      <td class="tg-9wq8">A todos los empleados</td>
                      <td class="tg-9wq8">Socialización</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación.</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="4">Normas de seguridad</td>
                      <td class="tg-9wq8" rowspan="4">Empleados y partes Interesadas</td>
                      <td class="tg-9wq8">Capacitaciones</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Protocolos o procedimientos de seguridad</td>
                      <td class="tg-9wq8">Cada que se actualizan</td>
                      <td class="tg-9wq8">Registro de entrega</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Señalización de emergencias</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Señalización</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Rutas de evacuación</td>
                      <td class="tg-9wq8">Permanente</td>
                      <td class="tg-9wq8">Planos</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="4">Plan de emergencia</td>
                      <td class="tg-9wq8" rowspan="4">Empleados y partes Interesadas</td>
                      <td class="tg-9wq8">Capacitaciones</td>
                      <td class="tg-9wq8">Dos veces al año</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Inducción</td>
                      <td class="tg-9wq8">Ingreso</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Reinducción</td>
                      <td class="tg-9wq8">Anual</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Cartilla para visitantes</td>
                      <td class="tg-9wq8">Cada vez que ingrese un visitante</td>
                      <td class="tg-9wq8">Registro de visitantes.</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Investigación de Incidentes y accidentes.</td>
                      <td class="tg-9wq8">Empleados y partes Interesadas</td>
                      <td class="tg-9wq8">Capacitación o charla</td>
                      <td class="tg-9wq8">Cuando se presente un casi accidente o accidente.</td>
                      <td class="tg-9wq8">Registro de capacitación</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8">Resultado de las auditorias</td>
                      <td class="tg-9wq8">Empleados y partes Interesadas</td>
                      <td class="tg-9wq8">Reunión</td>
                      <td class="tg-9wq8">Después de cada auditoria</td>
                      <td class="tg-9wq8">Cartelera</td>
                    </tr>
                    <tr>
                      <td class="tg-9wq8" rowspan="2">Revisión por la Dirección</td>
                      <td class="tg-9wq8">Todos los empleados</td>
                      <td class="tg-9wq8">Cartelera</td>
                      <td class="tg-9wq8">Después de cada revisión</td>
                      <td class="tg-9wq8">Cartelera</td>
                    </tr>
                    <tr>
                      <td class="tg-nrix">COPASST</td>
                      <td class="tg-nrix">Reunión</td>
                      <td class="tg-nrix">Después de cada revisión</td>
                      <td class="tg-nrix">Correo electrónico</td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                <strong>REPORTE DE ACTOS, CONDICIONES INSEGURAS Y AUTOREPORTE DE CONDICIONES DE SALUD</strong>
                <br>
                Se deberá socializar con los colaboradores el formato de reporte de condiciones, para que estos lo
                diligencien cada vez que identifiquen una condición o cuando sus condiciones de salud ameriten ser
                reportadas a la empresa.
              </li>
              <li>
                <strong>COMUNICACIONES EXTERNAS</strong>
                <br>
                Toda comunicación procedente de las partes interesadas debe ser resueltas por los medios solicitados en
                ellas, de lo contrario todas las comunicaciones serán contestadas por correo electrónico.
              </li>
            </ol>
          </b-row>

        </div>
      </div>
    </div>

  </Layout>
</template>

<style type="text/css">
.table-bordered {
    border: 1px solid #dcdce7;
}

.tg .tg-9wq8 {
  border-color: inherit;
  text-align: center;
  vertical-align: middle
}

.tg .tg-nrix {
  text-align: center;
  vertical-align: middle
}
</style>